import { Globe } from "lucide-react";
import { type Locale, localeCookieHeader, locales, useTranslation } from "../i18n";
import {
	Button,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from "./ui";
export function LanguageSwitcher({ className }: { className?: string; variant?: "header" | "footer" }) {
	const { locale, t } = useTranslation();
	const change = (value: string) => {
		document.cookie = localeCookieHeader(value as Locale);
		window.location.reload();
	};
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					className={className}
					aria-label={t("language.switch")}
					title={t("language.switch")}
				>
					<Globe aria-hidden="true" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" aria-label={t("language.switch")}>
				<DropdownMenuRadioGroup value={locale} onValueChange={change}>
					{locales.map(lang => (
						<DropdownMenuRadioItem key={lang} value={lang}>
							{lang === "ja" ? t("language.ja") : t("language.en")}
						</DropdownMenuRadioItem>
					))}
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
